<script>
import UploadPopover from "@/components/widgets/upload-popover.vue";
export default {
    name: 'AttachmentPR',
    components: {UploadPopover},
    props: {
        prId: {
            type: Number, 
            default: 0,
        },
        visible: Boolean,
        prFiles: {
            type: Array,
            default: () => []
        },
        managePR: Boolean
    },
    data() {
        return {
            addDocu: false,
            fileSearch: "",
            uploadOptions: {
                type: "Purchase Request",
                placement: "lefttop",
                folder: "Procurement",
            },
        }
    },
    computed: {
        searchDocu() {
            let data = this.prFiles;
            if (this.fileSearch.trim() != "" && this.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(this.fileSearch.toUpperCase());
                });
            }
            return data;
        },
    },
    methods: {
        openDocument(x) {
            this.readFile(x.id)
        },
    },
}
</script>
<template>
    <b-collapse
        :visible="visible"
        :accordion="`pending-attachment-accordion-${prId}`"
        role="tabpanel"
        >
        <hr />
        <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex">
                <p
                    class="mb-0"
                    v-if="prFiles.length == 0"
                >
                    <i>No documents found</i>
                </p>
                <input
                    v-if="prFiles.length > 0"
                    type="search"
                    class="form-control"
                    v-model="fileSearch"
                    placeholder="Search Documents..."
                />
            </div>
            <div class="">
                <a
                    href="javascript:void(0);"
                    class="text-primary border-primary border p-2"
                    :id="`pending-document${prId}`"
                    @click="addDocu = true"
                    v-if="managePR"
                >
                    <i class="bx bx-plus"></i>Upload Documents
                </a>
                <upload-popover
                    v-if="managePR"
                    :option="uploadOptions"
                    :sourceId="prId"
                    @uploaded="$emit('uploaded', $event)"
                    :showPV="addDocu"
                    @closePopover="addDocu = false"
                    :dzId="`dropzone-pending${prId}`"
                    :pvId="`pending-document${prId}`"
                ></upload-popover>
            </div>
        </div>
        <div class="mt-2">
            <b-row>
                <b-col
                    sm="3"
                    v-for="(y, index) in searchDocu"
                    :key="y.id"
                    class="mb-2"
                >
                    <div 
                        class="position-relative cursor-pointer"
                        :style="`z-index: ${prFiles.length - index}`"
                    >
                        <div class="border p-3">
                            <div>
                                <div class="float-end ms-2">
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        right
                                        variant="link"
                                        toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                        menu-class="dropdown-menu-end"
                                        no-caret
                                    >
                                        <template #button-content>
                                            <i class="mdi mdi-dots-horizontal"></i>
                                        </template>
                                        <b-dropdown-item
                                            @click="openDocument(y)"
                                        >
                                            <i class="bx bx-link-external me-1"></i>Open
                                        </b-dropdown-item>
                                        <b-dropdown-item
                                            variant="danger"
                                            v-if="managePR"
                                            @click="$emit('removeFile', y.id)"
                                        >
                                            <i class="bx bx-trash me-1"></i>
                                            Remove
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                                <div 
                                    class="avatar-xs me-3 mb-2"
                                    @click="openDocument(y)"
                                >
                                    <div class="avatar-title bg-transparent rounded">
                                        <i
                                            v-if="y.fileType.includes('image')"
                                            class="mdi mdi-image font-size-24 text-purple"
                                        ></i>
                                        <i 
                                            v-if="y.fileType.includes('application')"
                                            class="mdi mdi-file-pdf-outline font-size-24 text-danger"
                                        ></i>
                                    </div>
                                </div>
                                <div
                                    class="d-flex"
                                    @click="openDocument(y)"
                                >
                                    <div class="overflow-hidden me-auto">
                                        <h5 class="font-size-14 text-truncate mb-1">
                                            {{ y.description }}
                                        </h5>
                                        <p class="text-muted mb-0">
                                            {{ formatDateWithTime(new Date(y.dateTimeUploaded)) }}
                                        </p>
                                        <p class="text-muted mb-0" v-if="y.uploadedBy">
                                            Uploaded by {{ y.uploadedBy }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row
                v-if="searchDocu.length ==  0 && fileSearch"
            >
                <b-col
                    >Search Not
                    Found</b-col
                >
            </b-row>
        </div>
    </b-collapse>
</template>